import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';
import { AbstractSearchComponent } from '@shared/abstract-components/search/search.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';

@Component({
  selector: 'evland-header-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: [ './search-bar.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    RouterLink,
    ReactiveFormsModule,
    MatIcon,
    LazyLoadImageModule,
    NgbDropdown,
    NgbDropdownMenu,
    NgbDropdownItem,
  ],
})
export class SearchBarComponent extends AbstractSearchComponent {
  @ViewChild(NgbDropdown) dropdown: any;
}
